export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";